// Interface

import util from '@/utils/classToObject'
import { ICatalogueState } from './state'

export class CatalogueGetter {
    
    public familles(state: ICatalogueState) {
        return state.familles
    }
    public famillesList(state:ICatalogueState){
        return state.famillesList.item.map( id => state.familles[id] )
    }

    public marques(state: ICatalogueState) {
        return state.marques
    }
    public marquesList(state:ICatalogueState){
        return state.marquesList.item.map( id => state.marques[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }

    public rubriques(state: ICatalogueState) {
        return state.rubriques
    }
    public rubriquesList(state:ICatalogueState){
        return state.rubriquesList.item.map( id => state.rubriques[id] )
    }

    public dispos(state: ICatalogueState) {
        return state.dispos
    }
    public disposList(state:ICatalogueState){
        return state.disposList.item.map( id => state.dispos[id] )
    }

    public enseignes(state: ICatalogueState) {
        return state.enseignes
    }
    public enseignesList(state:ICatalogueState){
        return state.enseignesList.item.map( id => state.enseignes[id] )
    }

    public transporters(state: ICatalogueState) {
        return state.transporters
    }
    public transportersList(state:ICatalogueState){
        return state.transportersList.item.map( id => state.transporters[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }

    public tarifModels(state: ICatalogueState) {
        return state.tarifModels
    }
    public tarifModelsList(state:ICatalogueState){
        return state.tarifModelsList.item.map( id => state.tarifModels[id] )
    }

    public statutCompactGroups(state: ICatalogueState) {
        return state.statutCompactGroups
    }
    public statutCompactGroupsList(state:ICatalogueState){
        return state.statutCompactGroupsList.item.map( id => state.statutCompactGroups[id] )
    }

    public fluxBuildersStatus(state: ICatalogueState) {
        return state.fluxBuildersStatus
    }
    
    public fluxBuilders(state: ICatalogueState) {
        return state.fluxBuilders
    }
    public fluxBuildersList(state:ICatalogueState){
        return state.fluxBuildersList.item.map( id => state.fluxBuilders[id] )
    }

    public fluxRestrictedFlag(state: ICatalogueState) {
        return state.fluxRestrictedFlag
    }

    public metasStatus(state: ICatalogueState) {
        return state.metasStatus
    }
    public metas(state: ICatalogueState) {
        return state.metas
    }
    public metasList(state:ICatalogueState){
        return state.metasList.item.map( id => state.metas[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }

    public metaGroups(state: ICatalogueState) {
        return state.metaGroups
    }
    public metaGroupsList(state:ICatalogueState){
        return state.metaGroupsList.item.map( id => state.metaGroups[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }

    public partRestrictedFlag(state: ICatalogueState) {
        return state.partRestrictedFlag
    }

    public univers(state: ICatalogueState) {
        return state.univers
    }
    public universList(state:ICatalogueState){
        return state.universList.item.map( id => state.univers[id] )
    }
}

export default util.classToObject(CatalogueGetter)